import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-scroll';
import { DBIntField } from '_components';
import { PatientCareCenterNoteSection } from '../Section';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupGait } from './GroupGait';
import { PatientCareCenterNoteChargesGroupModalities } from './GroupModalities';
import { PatientCareCenterNoteChargesGroupOther } from './GroupOther';
import { PatientCareCenterNoteChargesGroupSection } from './GroupSection';
import { RefManager } from '_helpers';

class PatientCareCenterNoteChargesGroup extends React.Component {

    linkClicked(to) {
        RefManager.scrollToRef(to);
    }

    render() {
        return (
            <PatientCareCenterNoteSection
                id='charges_group'
                name={this.props.groupTime === 0 ? 'Group Therapy' : 'Group Therapy (' + this.props.groupTime + ' min)'}
                level={1}
                className={styles.required}>

                {this.props.groupCount > 1 &&
                    <div className={styles.al_message}>
                        <Link to='al' containerId={this.props.noteId} spy={true} smooth={true}>
                            You may only specify one Group Therapy - 97150 code on the Activity Log.  Please click here to fix.
                        </Link>
                    </div>
                }
                {this.props.groupTime === 0 &&
                    <div className={styles.al_message}>
                        <Link to='al' containerId={this.props.noteId} spy={true} smooth={true}>
                            You must specify the time for Group Therapy - 97150 code on the Activity Log.  Please click here to fix.
                        </Link>
                    </div>
                }
                {this.props.groupCount === 1 && this.props.groupTime > 0 &&
                    <div>
                        <div className={styles.row}>
                            <span className={styles.col1_req}>
                                How many patients were treated within the group setting?
                            </span>

                            <span className={styles.col2}>
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='MLEXLOG'
                                    entityKeyColumn='XLNO'
                                    entityKeyValue={this.props.xlno}
                                    field='XLNUMINGROUP'
                                    className={styles.int_field}
                                    min={0}
                                />
                            </span>
                        </div>
                        {this.props.performedCount > 0 &&
                            <div className={styles.row}>
                                Which treatment(s) were delivered while in a group setting?
                            </div>
                        }
                        {this.props.performedCount === 0 &&
                            <div className={styles.al_message}>
                                <Link to='al' containerId={this.props.noteId} spy={true} smooth={true}>
                                    You must specify at least one treatment as performed in the Activity Log.  Please click here to fix.
                                </Link>
                            </div>
                        }

                        <PatientCareCenterNoteChargesGroupSection
                            name='Therapeutic Activities (97530)'
                            table='MLTHERACT'
                            prefix='XLTA'
                            masterTable='MLMASTERTHERACT'
                            masterPrefix='TA'
                            exlogColumn='XLTIMETHERACT'
                        />
                        <PatientCareCenterNoteChargesGroupSection
                            name='Self-Care (97535)'
                            table='MLSELFCARE'
                            prefix='XLSC'
                            masterTable='MLMASTERSELFCARE'
                            masterPrefix='SC'
                            exlogColumn='XLTIMESELFCARE'
                        />
                        <PatientCareCenterNoteChargesGroupSection
                            name='Neuromuscular Re-Ed (97112)'
                            table='MLNEURO'
                            prefix='XLNE'
                            masterTable='MLMASTERNEURO'
                            masterPrefix='NE'
                            exlogColumn='XLTIMENEURO'
                        />
                        <PatientCareCenterNoteChargesGroupSection
                            name='Therapeutic Exercise (97110)'
                            table='MLTHEREX'
                            prefix='XLTE'
                            masterTable='MLMASTERTHEREX'
                            masterPrefix='TE'
                            exlogColumn='XLTIMETHEREX'
                        />
                        <PatientCareCenterNoteChargesGroupSection
                            name='Manual Therapy (97140)'
                            table='MLMANUAL'
                            prefix='XLMA'
                            masterTable='MLMASTERMANUAL'
                            masterPrefix='MA'
                            exlogColumn='XLTIMEMANUAL'
                        />

                        <PatientCareCenterNoteChargesGroupGait />

                        <PatientCareCenterNoteChargesGroupSection
                            name='Aquatics (97113)'
                            table='MLAQUATICS'
                            prefix='XLAQ'
                            masterTable='MLMASTERAQUATICS'
                            masterPrefix='AQ'
                            exlogColumn='XLTIMEAQUA'
                        />

                        <PatientCareCenterNoteChargesGroupModalities />

                        <PatientCareCenterNoteChargesGroupOther />
                    </div>
                }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let groupCount = Object.keys(state.entities.notes.MLOTHER)
        .filter(key => {
            if (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                Object.keys(state.entities.masterData.MLMASTEROTHER)
                    .find(x => state.entities.masterData.MLMASTEROTHER[x].OENO === state.entities.notes.MLOTHER[key].XLOEOENO &&
                        state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                    ) !== undefined) {
                return true;
            }
            return false;
        }).length;
    let groupTime = state.entities.notes.MLOTHER[Object.keys(state.entities.notes.MLOTHER)
        .find(key => {
            if (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                Object.keys(state.entities.masterData.MLMASTEROTHER)
                    .find(x => state.entities.masterData.MLMASTEROTHER[x].OENO === state.entities.notes.MLOTHER[key].XLOEOENO &&
                        state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                    ) !== undefined) {
                return true;
            }
            return false;
        })].XLOETIME;
    groupTime = groupTime ? groupTime : 0;

    let groupKey = Object.keys(state.entities.masterData.MLMASTEROTHER)
        .find(x => state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150');

    let performedCount = Object.keys(state.entities.notes.MLTHERACT)
        .filter(key => state.entities.notes.MLTHERACT[key].XLTAXLNO === xlno &&
            state.entities.notes.MLTHERACT[key].XLTAPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLSELFCARE)
            .filter(key => state.entities.notes.MLSELFCARE[key].XLSCXLNO === xlno &&
                state.entities.notes.MLSELFCARE[key].XLSCPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLNEURO)
            .filter(key => state.entities.notes.MLNEURO[key].XLNEXLNO === xlno &&
                state.entities.notes.MLNEURO[key].XLNEPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLTHEREX)
            .filter(key => state.entities.notes.MLTHEREX[key].XLTEXLNO === xlno &&
                state.entities.notes.MLTHEREX[key].XLTEPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLMANUAL)
            .filter(key => state.entities.notes.MLMANUAL[key].XLMAXLNO === xlno &&
                state.entities.notes.MLMANUAL[key].XLMAPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLGAIT)
            .filter(key => state.entities.notes.MLGAIT[key].XLGAXLNO === xlno &&
                state.entities.notes.MLGAIT[key].XLGAPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLAQUATICS)
            .filter(key => state.entities.notes.MLAQUATICS[key].XLAQXLNO === xlno &&
                state.entities.notes.MLAQUATICS[key].XLAQPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLMODALITIES)
            .filter(key => state.entities.notes.MLMODALITIES[key].XLMDXLNO === xlno &&
                state.entities.notes.MLMODALITIES[key].XLMDPERFORMED === true).length
        +
        Object.keys(state.entities.notes.MLOTHER)
            .filter(key => state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                state.entities.notes.MLOTHER[key].XLOEOENO !== groupKey).length;



    return {
        noteId,
        noteType,
        xlno,
        groupTime,
        groupCount,
        performedCount,
    };
}

const connectedPatientCareCenterNoteChargesGroup = connect(mapStateToProps)(PatientCareCenterNoteChargesGroup);
export { connectedPatientCareCenterNoteChargesGroup as PatientCareCenterNoteChargesGroup };

